import {
    Card,
    CardContent,
    CardHeader,
    Grid,
    Paper,
    Stack,
    Tooltip,
    Typography,
} from "@mui/material";

import EventIcon from "@mui/icons-material/Event";
import GridViewIcon from "@mui/icons-material/GridView";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import { SYSTEMS } from "../../../constants";

export const SystemStatistics = ({ statistic, showSystemLabel }) => (
    <Grid size="auto">
        <Paper sx={{ p: 1 }} elevation={5}>
            {showSystemLabel && (
                <Typography variant="h6" sx={{ textAlign: "center" }}>
                    {statistic.system}
                </Typography>
            )}
            <Stack
                direction="row"
                spacing={1}
                sx={{ justifyContent: "center" }}
            >
                {statistic.system !== SYSTEMS.LITERAL ? (
                    <>
                        <CardCount
                            icon={<LocationOnIcon fontSize="small" />}
                            plannedCount={statistic.plannedSiteCount}
                            receivedCount={statistic.receivedSiteCount}
                            title="Sites"
                        />
                        <CardCount
                            icon={<EventIcon fontSize="small" />}
                            plannedCount={statistic.plannedTotalMissionsCount}
                            receivedCount={statistic.receivedTotalMissionsCount}
                            title="Dates"
                        />
                        <CardCount
                            icon={<GridViewIcon fontSize="small" />}
                            plannedCount={statistic.plannedFeatureCount}
                            receivedCount={statistic.receivedFeatureCount}
                            title="Plots"
                        />
                    </>
                ) : (
                    <CardCount
                        icon={<PhotoCameraIcon fontSize="small" />}
                        plannedCount={statistic.plannedAcquisitionCount}
                        receivedCount={statistic.receivedAcquisitionCount}
                        title="Acquisitions"
                    />
                )}
            </Stack>
        </Paper>
    </Grid>
);

const MIN_LIMITS_COLOR = Object.freeze({ YELLOW: 1, GREEN: 100, RED: 120 });

const CardCount = ({ icon, plannedCount, receivedCount, title }) => {
    const percentage = Math.round((receivedCount / plannedCount) * 100);
    const color =
        plannedCount === 0 || percentage > MIN_LIMITS_COLOR.RED
            ? "error.main"
            : percentage >= MIN_LIMITS_COLOR.GREEN
              ? "success.main"
              : "warning.main";

    return (
        <Card
            sx={{
                border: 2,
                borderColor: color,
                minWidth: "100px",
                textAlign: "center",
            }}
        >
            <CardHeader
                title={title}
                avatar={icon}
                titleTypographyProps={{ variant: "subtitle2" }}
                sx={{
                    backgroundColor: color,
                    px: 1,
                    py: 0,
                    ".MuiCardHeader-avatar": { mr: 0 },
                }}
            />
            <CardContent sx={{ p: 0, ":last-child": { p: 0 } }}>
                <Typography variant="h6" color={color}>
                    {plannedCount ? `${percentage}%` : "--"}
                </Typography>
                <Tooltip title="Received / Planned">
                    <Typography variant="body2">{`${receivedCount} / ${plannedCount}`}</Typography>
                </Tooltip>
            </CardContent>
        </Card>
    );
};
